
class ActionResourceArray {
    constructor() {
        this.status = "NO_ACTION"
        this.value = null
        this.error = null

        this.statusValue = {
            REQUEST: "REQUEST",
            REQUEST_SUCCESS: "REQUEST_SUCCESS",
            REQUEST_FAIL: "REQUEST_FAILURE",
            NO_ACTION: "NO_ACTION",
        }
    }

    setStatus(status) {
        this.status = status
    }

    setValue(value) {
        this.value = value
    }

    getDatas() {
        return this.value
    }

    getDataById(id) {
        if (Array.isArray(this.value)) {
            return this.value.find(v => v._id === id)
        }

        return null
    }
}

export default ActionResourceArray


// WEBPACK FOOTER //
// ./src/app/core/ActionResourceArray.js